import { ConfigProvider as AntdConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AppRouter } from 'routing/AppRouter';

import { Spin } from './components/common';
import { getIsOrgLoading } from './modules/organization/organizationSlice';
import { StoreProvider } from './redux/store/StoreProvider';

function AppContent() {
  const isLoading = useSelector(getIsOrgLoading);

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 z-50 bg-white/60 flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
      <AppRouter />
      <ToastContainer />
    </>
  );
}

function App() {
  return (
    <StoreProvider>
      <AntdConfigProvider>
        <AppContent />
      </AntdConfigProvider>
    </StoreProvider>
  );
}

export default App;
